export interface HasId {
	id: number;
}

export type NullableHasId = HasId | null | undefined;

export function getId<T extends NullableHasId>(entity: T) { return entity ? entity.id : null };

export function isSame<T extends NullableHasId>(entity1: T, entity2: T) { return getId(entity1) === getId(entity2) };

export function isSameArray<T extends NullableHasId>(a: T[] | null | undefined, b: T[] | null | undefined) {
	if (a === null || a === undefined) {
		return b === null || b === undefined;
	}

	if (b === null || b === undefined)
		return false;

	return a.length === b.length && a.every((val, index) => getId(val) === getId(b[index]));
};

export function filterUniques<T extends HasId>(array: T[]): T[] {
	let filteredArray = array.filter((element, index) => array.findIndex($ => $.id === element.id) === index);
	return filteredArray;
}